import Loader from 'components/base/Loader';
import useAuth from 'hooks/useAuth';
import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';

function PermissionHandler() {
  const { isValidAuth, isLoading } = useAuth();
  return isValidAuth ? (
    isLoading ? (
      <Loader />
    ) : (
      <Outlet />
    )
  ) : (
    <Navigate to="/" />
  );
}

export default PermissionHandler;
